// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__27Lsa","card":"Cards_card__IWeA5","infected":"Cards_infected__79mM3","recovered":"Cards_recovered__2k13Y","deaths":"Cards_deaths__3p6S6"};